<p-dropdown
  *ngIf="isBurtAdmin"
  [options]="accounts"
  [(ngModel)]="selectedAccount"
  (onChange)="onAccountSelect($event.value)"
  placeholder="Select an account"
  optionLabel="name"
  [filter]="true"
  filterBy="name"
  [scrollHeight]="'80vh'"
></p-dropdown>
